module.exports = __webpack_public_path__ + "img/dataset_edit.8551c656.png";